import React, { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import jsPDF from "jspdf";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import employeeLogo from "../../images/employee.png";
import { purchaseItems, remSelectedPurchase } from "../inventory/itemsSlice";
import { getQty } from "../../utils/getQty";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Stack, styled, Typography } from "@mui/material";
import { Toast } from "../components/Toast";
import Repo from "../../Repository/Repo";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

const TotalBox = styled(Box)({
  backgroundColor: "white",
  borderRadius: "20px",
  margin: "0px 5px",
  padding: "15px 10px",
  boxShadow: "0px 3px 6px #c2c1c1",
  color: "#757575",
  float: "right",
  width: "30%",
  marginTop: "10px",
});

function OutPurchase(props) {
  const {
    user,
    selectedVendor,
    selectedLedger,
    ledger_detail,
    selectedToSale,
  } = props.location.state;

  const history = useHistory();
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");
  const [state, setState] = useState({
    items: selectedToSale,
    isLoad: false,
    bill: true,
    selectedVendor: "",
    selectedLedger: "",
    user: "",
    date: "",
    newQuantity: 0,
  });

  const totalPrice = () => {
    let Total = 0;
    let discAmount = 0;
    state.items.map((item) => {
      let newQty = item.newQuantity ? parseFloat(item.newQuantity) : 1;
      let saleDiscount = item.saleDiscount;
      let price = item.newPrice
        ? parseFloat(item.newPrice)
        : parseFloat(item.companyPrice);
      Total += newQty * price;

      if (saleDiscount) {
        let dis = (saleDiscount / 100) * (newQty * price);
        discAmount += dis;
      }
    });
    let total = Total % 1 === 0 ? Total : parseFloat(Total).toFixed(3);
    return total - discAmount;
  };

  const updateInventory = async (arg) => {
    await Repo.default({
      request: {
        method: "updateItem",
        data: {
          items: arg,
          action: "Purchase",
          user: localStorage.getItem("token"),
        },
      },
    });
  };

  const updateLed = async (prNum) => {
    await Repo.ledger({
      request: {
        method: "updatePurchaseLedger",
        data: {
          _id: selectedLedger,
          purchase: {
            srNum: uuidv4(),
            billNumber: prNum,
            date: +new Date(),
            detail: `Purchase Order # ${prNum} entry created`,
            totalAmount: totalPrice(),
            depositedAmount: 0,
            remainingAmount: totalPrice(),
          },
        },
      },
    });
  };

  const createPurchase = async () => {
    let { data } = await Repo.purchases({
      request: {
        method: "savePurchase",
        data: {
          company_code: companyCode,
          purchase: {
            company_code: companyCode,
            items: state.items,
            ship: {
              name: user.name,
              city: user?.address?.city,
              company: user?.company_name,
              street: user?.address?.street,
              phone: user?.address?.phone,
            },
            vendor: selectedVendor,
            ledger: selectedLedger,
            ledger_detail: ledger_detail,
            paid: 0,
            user_id: localStorage.getItem("email"),
            remaining: totalPrice() || 0,
            srNum: uuidv4(),
          },
        },
      },
    });
    console.log("data:", data);
    if (data.response.data.purchaseNumber) {
      return data.response.data.purchaseNumber;
    } else {
      Toast("error", "Error");
      return null;
    }
  };

  const handleUpdate = async () => {
    try {
      let found = state.items.find((item) => item.newQuantity == "");
      if (found) {
        Toast("info", "New Quantity Cannot be Empty");
        return;
      }
      setState((pre) => ({ ...pre, isLoad: true }));
      let updatedItems = [];

      let fullItems = [];
      state.items.forEach((item) => {
        let qty = item.newQuantity ? item.newQuantity : 1;
        if (foundBatch()) {
          if (item.batchNo) {
            let updateItem = {
              _id: item._id,
              purchaseQuantity: qty,
              batchNo: item.batchNo,
            };
            // let found = item.batchNumber.find(
            //   (i) => i.batchNumber == item.batchNo
            // );
            // found.quantity = parseInt(found.quantity) + parseInt(qty);
            updatedItems.push(updateItem);

            fullItems.push({ ...item, purchaseQuantity: qty });
          } else {
            let updateItem = {
              _id: item._id,
              purchaseQuantity: qty,
            };
            updatedItems.push(updateItem);
            fullItems.push({ ...item, purchaseQuantity: qty });
          }
        } else {
          let updateItem = {
            _id: item._id,
            purchaseQuantity: qty,
          };
          updatedItems.push(updateItem);
          fullItems.push({ ...item, purchaseQuantity: qty });
        }
      });

      dispatch(remSelectedPurchase());
      dispatch(purchaseItems(updatedItems));
      let res = await createPurchase();
      if (res) {
        Promise.all([updateInventory(fullItems), updateLed(res)])
          .then((res) => {
            setState((pre) => ({ ...pre, isLoad: false }));
            history.push("/inventory/admin/purchase-order/finalized");
          })
          .catch((err) => {
            console.log(err);
            setState((pre) => ({ ...pre, isLoad: false }));
          });
      } else {
        setState((pre) => ({ ...pre, isLoad: false }));
      }
    } catch (err) {
      console.log("err:", err);
      setState((pre) => ({ ...pre, isLoad: false }));
    }
  };

  const removeItem = (name) => {
    let copyItems = JSON.parse(JSON.stringify(state.items));
    var obj = copyItems.filter(function (item) {
      return item._id != name._id;
    });
    setState((pre) => ({ ...pre, items: obj }));
  };

  const handleChange = (e, index) => {
    let { name, value } = e.target;

    let copyItems = JSON.parse(JSON.stringify(state.items));
    if (name == "batchNo") {
      if (value) {
        let found = copyItems[index].batchNumber.find(
          (i) => i.batchNumber == value
        );

        copyItems[index].batchNo = value;
        copyItems[index].batchQty = found.quantity;
        copyItems[index].batchExpiry = moment(found.expiryDate).format(
          "DD-MM-YYYY"
        );
        setState((pre) => ({ ...pre, items: copyItems }));
      } else {
        copyItems[index].batchNo = null;
        copyItems[index].batchQty = null;
        copyItems[index].batchExpiry = null;
        setState((pre) => ({ ...pre, items: copyItems }));
      }
    } else {
      state.items[index][name] = value;
    }
  };

  const foundBatch = () => {
    let found = selectedToSale.find((item) => {
      if (item?.batchNumber && item?.batchNumber.length > 0) {
        return item;
      }
    });
    if (found) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box sx={{ mt: "30px", mb: "30px" }}>
      <div className="table-titles-sell">
        <h3 className="center regular">#</h3>
        <h3 className="regular">Item</h3>
        <h3 className="regular"> Qty</h3>
        {foundBatch() && <h3 className="regular"> Batch #</h3>}
        <h3 className="regular">New Qty</h3>
        <h3 className="regular">U Price</h3>
        <h3 className="regular">Dis%</h3>
        <h3 className="regular">Price</h3>
      </div>

      {state.items.map((item, index) => {
        let newQty = item.newQuantity || 1;
        let price = item.newPrice
          ? parseFloat(item.newPrice)
          : parseFloat(item.companyPrice);
        let saleDiscount = item.saleDiscount;
        let finalPrice = newQty * price;
        if (saleDiscount) {
          let dis = (saleDiscount / 100) * finalPrice;
          finalPrice -= dis;
        }

        return (
          <div key={index} className="table-values-sell">
            <h3 className="center regular">{index + 1}</h3>
            <h3 className=" regular">{item.name}</h3>

            <h3 className="regular">
              {item.batchNo ? item.batchQty : getQty(item)?.qty}
            </h3>
            {foundBatch() && (
              <>
                {item?.batchNumber && item?.batchNumber.length > 0 ? (
                  <FormControl size="small" sx={{ width: "100px" }}>
                    <InputLabel>Batch #</InputLabel>
                    <Select
                      variant="standard"
                      value={item?.batchNo || ""}
                      label="Batch #"
                      name="batchNo"
                      onChange={(e) => handleChange(e, index)}
                    >
                      <MenuItem value="">None</MenuItem>
                      {item?.batchNumber.map((item, ind) => {
                        return (
                          <MenuItem key={ind} value={item.batchNumber}>
                            {item.batchNumber}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl
                    size="small"
                    sx={{ width: "100px" }}
                  ></FormControl>
                )}
              </>
            )}
            <Stack alignItems="flex-start" justifyContent="center">
              <input
                className="new-input-sale"
                autoFocus
                type="number"
                name="newQuantity"
                min="0"
                value={newQty}
                onChange={(e) => handleChange(e, index)}
              />
            </Stack>
            <Stack alignItems="flex-start" justifyContent="center">
              <input
                className="new-input-sale"
                type="number"
                name="newPrice"
                value={item.newPrice ? item.newPrice : item.companyPrice}
                onChange={(e) => handleChange(e, index)}
              />
            </Stack>
            <Stack alignItems="flex-start" justifyContent="center">
              <input
                className="new-input-sale"
                type="number"
                name="saleDiscount"
                value={item.saleDiscount || ""}
                onChange={(e) => handleChange(e, index)}
              />
            </Stack>
            <h3 className="regular">
              {finalPrice % 1 === 0 ? finalPrice : finalPrice.toFixed(3)}
            </h3>
            <Stack alignItems="center" justifyContent="center">
              <DeleteForeverIcon
                sx={{ color: "#e74c3c", width: "30px", height: "30px" }}
                onClick={() => removeItem(item)}
              />
            </Stack>
          </div>
        );
      })}

      <TotalBox>
        <Stack direction="row" justifyContent="space-between" padding="5px">
          <Typography>Total:</Typography>
          <Typography>{totalPrice()}</Typography>
        </Stack>

        <hr />
        <Stack alignItems="center" justifyContent="center" padding="5px">
          {state.isLoad == true && (
            <ClipLoader size={50} color={"#4DAF51"} loading={state.isLoad} />
          )}
          {state.isLoad == false && (
            <button className="print-btn" onClick={handleUpdate}>
              Purchase Now
            </button>
          )}
        </Stack>
      </TotalBox>
    </Box>
  );
}

export default OutPurchase;
